import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { TagAction } from 'tag/ts/tag/model/enums/TagAction';
export class SiteUtilities extends AbstractTagClass {
    #siteSessionData;
    constructor(argument) {
        super({
            ...argument,
            name: 'SiteUtilities'
        });
    }
    get siteSessionData() {
        return this.#siteSessionData;
    }
    getSiteSessionData = (target = undefined) => {
        return new Promise((resolve) => {
            const sessionData = this.TAG_API.tagAction({
                action: TagAction.GET_SESSION_DATA,
                uuid: this.uuid
            }, true);
            if (this.utils.Type.isPromise(sessionData)) {
                sessionData.then((data) => {
                    this?.logger?.log('getSiteSessionData:', 'target:', target, 'Page session data received:', data.sessionData);
                    this.#siteSessionData = data.sessionData;
                    resolve(data.sessionData);
                }).catch((error) => {
                    this?.logger?.log('getSiteSessionData:', 'target:', target, 'Page session data ERROR:', error, 'Continue without session data.');
                    this.#siteSessionData = undefined;
                    resolve(undefined);
                });
            }
            else {
                this?.logger?.log('getSiteSessionData:', 'target:', target, 'Page did not return promise. Check if method exists in DOM.', 'Continue without page session data.');
                this.#siteSessionData = undefined;
                resolve(undefined);
            }
        });
    };
}
